import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const OFRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnWebOrder,
  rutinInfos.rtnKreditorder,
  rutinInfos.rtnFaktura,
  rutinInfos.rtnKundfakturabunt,
  rutinInfos.rtnOrderunderlag,
  rutinInfos.rtnArtiklar,
  rutinInfos.rtnFakturatext,
  rutinInfos.rtnPrislista,
  rutinInfos.rtnKund,
  rutinInfos.rtnPrisavtal,
  rutinInfos.rtnOrderrad,
  rutinInfos.rtnRantefakturering,
  rutinInfos.rtnRanteomgang,
  rutinInfos.rtnArtikelgrupp,
  rutinInfos.rtnEnhet,
  rutinInfos.rtnOrderkategori,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnOrgPersLok,
];

export default OFRutinMeny;
